/**
 * Vehicle feature item type values
 */
export enum VehicleFeatureItemTypeEnum {
	VEHICLE_STANDARD = 'vehicle_standard',
	VEHICLE_EXTRA = 'vehicle_extra',
}
